"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalProp = optionalProp;
function optionalProp(key, value, mapper) {
    if (value === undefined || value === null)
        return undefined;
    return {
        [key]: mapper ? mapper(value) : value,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3B0aW9uYWwtcHJvcGVydHkudXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvb2JqZWN0LXV0aWxzL29wdGlvbmFsLXByb3BlcnR5LnV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBMEJBLG9DQVVDO0FBVkQsU0FBZ0IsWUFBWSxDQUMxQixHQUFNLEVBQ04sS0FBMkIsRUFDM0IsTUFBcUM7SUFFckMsSUFBSSxLQUFLLEtBQUssU0FBUyxJQUFJLEtBQUssS0FBSyxJQUFJO1FBQUUsT0FBTyxTQUFTLENBQUE7SUFFM0QsT0FBcUI7UUFDbkIsQ0FBQyxHQUFHLENBQUMsRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSztLQUN0QyxDQUFBO0FBQ0gsQ0FBQyJ9